<script setup lang="ts">
defineProps<{ direction: 'previous' | 'next' }>()
</script>

<template>
  <svg class="navigation-arrow" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <g :transform="direction === 'next' ? 'rotate(180 12 12)' : undefined">
      <path d="M22 6.426v11.148c0 1.847-1.6 3.015-2.903 2.118L13 15.232V8.768l6.097-4.46C20.399 3.411 22 4.58 22 6.426" opacity=".5" />
      <path d="M13 7.123v9.754c0 1.616-1.467 2.638-2.661 1.853L2.92 13.853c-1.228-.807-1.228-2.899 0-3.706l7.42-4.877c1.193-.785 2.66.237 2.66 1.853" />
    </g>
  </svg>
</template>

<style scoped>
.navigation-arrow {
  display: block;
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  opacity: 0.5;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

a:focus-visible .navigation-arrow {
  opacity: 0.2;
  transform: scale(2);
}

@media (hover: hover) and (pointer: fine) {
  a:hover .navigation-arrow {
    opacity: 0.2;
    transform: scale(2);
  }

  @media (prefers-reduced-motion: reduce) {
    a:hover .navigation-arrow {
      transform: none;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .navigation-arrow {
    transition: none;
  }

  a:focus-visible .navigation-arrow {
    transform: none;
  }
}
</style>
